// Configuração automática da API baseada no ambiente
// Este arquivo detecta automaticamente se está em desenvolvimento ou produção

/**
 * Detecta o ambiente baseado em várias condições:
 * 1. process.env.NODE_ENV
 * 2. process.env.REACT_APP_ENV 
 * 3. hostname (localhost vs railway)
 * 4. variável REACT_APP_API_URL
 */
const detectEnvironment = () => {
  // Verificar variável de ambiente customizada PRIMEIRO (mais explícita)
  const envSetting = process.env.REACT_APP_ENV;
  if (envSetting === 'production') return 'production';
  if (envSetting === 'staging') return 'staging';
  if (envSetting === 'development') return 'development';

  // Fallback: NODE_ENV + hostname
  const isReactDev = process.env.NODE_ENV === 'development';
  const isLocalhost = typeof window !== 'undefined' &&
                     (window.location.hostname === 'localhost' ||
                      window.location.hostname === '127.0.0.1');

  if (isReactDev && isLocalhost) return 'development';

  // Default para produção se não conseguir detectar
  return 'production';
};

/**
 * URLs dos backends por ambiente
 */
const API_URLS = {
  development: 'http://localhost:3001',
  staging:     'https://pagmus-backend-staging-production.up.railway.app',
  production:  'https://pagmus-backend-production.up.railway.app',
};

/**
 * URLs do frontend por ambiente (para links de afiliado, checkout, etc.)
 */
const FRONTEND_URLS = {
  development: 'http://localhost:3002',
  staging:     'https://pagmus-frontend-staging.vercel.app',
  production:  'https://app.pagmus.com.br',
};

/**
 * URLs da API de Payments por ambiente
 */
const PAYMENTS_API_URLS = {
  development: 'http://localhost:3003',
  staging:     'https://pagmus-payments-production.up.railway.app',
  production:  'https://pagmus-payments-production.up.railway.app',
};

/**
 * API Keys da API de Payments por ambiente
 */
const PAYMENTS_API_KEYS = {
  development: 'pk_test_key',
  staging:     'pk_9fd4bfe62e5e4fb0824c0c6b87a1e8ea',
  production:  'pk_9fd4bfe62e5e4fb0824c0c6b87a1e8ea',
};

/**
 * Configuração da API baseada no ambiente
 */
const getApiConfig = () => {
  const environment = detectEnvironment();
  
  // Permitir override manual via env var
  const manualUrl = process.env.REACT_APP_API_URL;
  const apiUrl = manualUrl || API_URLS[environment];
  
  const config = {
    environment,
    baseURL: apiUrl,
    timeout: environment === 'development' ? 10000 : 30000, // 10s local, 30s remoto
    headers: {
      'Content-Type': 'application/json',
    }
  };
  
  // Configuração silenciosa - sem logs
  
  return config;
};

/**
 * Status de debug para desenvolvimento
 */
const getDebugInfo = () => {
  const config = getApiConfig();
  
  return {
    ...config,
    buildTime: new Date().toISOString(),
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'server',
    url: typeof window !== 'undefined' ? window.location.href : 'server',
    referrer: typeof document !== 'undefined' ? document.referrer : 'server'
  };
};

// Debug info disponível via getDebugInfo() quando necessário - sem logs automáticos

/**
 * Obter URL do frontend baseada no ambiente
 */
const getFrontendUrl = () => {
  const environment = detectEnvironment();

  // Permitir override manual via env var
  const manualUrl = process.env.REACT_APP_FRONTEND_URL;
  return manualUrl || FRONTEND_URLS[environment];
};

/**
 * Obter URL da API de Payments baseada no ambiente
 */
const getPaymentsApiUrl = () => {
  const environment = detectEnvironment();
  return PAYMENTS_API_URLS[environment];
};

/**
 * Obter API Key da API de Payments baseada no ambiente
 */
const getPaymentsApiKey = () => {
  const environment = detectEnvironment();
  return PAYMENTS_API_KEYS[environment];
};

// Compatibilidade com código existente
export const API_URL = getApiConfig().baseURL;
export const FRONTEND_URL = getFrontendUrl();
export const PAYMENTS_API_URL = getPaymentsApiUrl();
export const PAYMENTS_API_KEY = getPaymentsApiKey();

export {
  getApiConfig,
  getDebugInfo,
  detectEnvironment,
  API_URLS,
  FRONTEND_URLS,
  PAYMENTS_API_URLS,
  getFrontendUrl,
  getPaymentsApiUrl,
  getPaymentsApiKey
};

export default getApiConfig();











